import * as fetcher from "../fetcher";

export interface EmailAttachment {
  id: number;
  fileName: string;
  fileDownloadUri: string;
  contentType: string;
  size: number;
}

export const uploadAttachment = async (
  opportunityId: number,
  file: File
): Promise<EmailAttachment> => {
  const response = await fetcher.opportunity.upload(
    `/communication/${opportunityId}/attachments`,
    file
  );

  return response.json();
};

export const deleteAttachment = async (
  opportunityId: number,
  attachmentId: number
) => {
  const res = await fetcher.opportunity.remove(
    `/communication/${opportunityId}/attachments/id/${attachmentId}`
  );
  return res;
};
